import React, { useEffect, useState, } from 'react'
import { Modal } from 'react-bootstrap';
import HtmlParser from 'react-html-parser';
import axios from 'axios';

import 'react-tempusdominus-bootstrap';

import {
    buttonProcessGet, responseGet, globalSettings, styles, sendMessageCloseCurrentWindowAsync, charactersRemainingGet, dateTimeFormatGlobalSet, languageObjGet,
    isUndNullEmp, awaitDelay,
} from '../../helpers/settings'
import { GlobalFormats } from '../../classes/main/globalFormats';
import { buildingModelGet } from '../../models/buildings/building';
import { commonAreaModelGet } from '../../models/commonArea/commonArea';

const currentMethod = 'CommonAreaAddEditDetails';

const { icons, images, labels, messages, } = globalSettings;

export default function CommonAreaAddEditDetails({
    $ = {},
    processValues = {
        auth: {},
        dtId: '',
        showModal: false,
        setShowModal: () => { },
        rowIndex: 0,
        type: 0,
        user: {},
    },
    building = buildingModelGet({}),
    buildingTwo = buildingModelGet({}),
    commonArea = commonAreaModelGet({}),
    setCommonArea = () => { },
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const remarkMaxLength = 250;
    const [areaError, setAreaError] = useState('');
    const [remarkError, setRemarkError] = useState('');
    const [remarkRemaining, setRemarkRemaining] = useState('');
    const controls = {
        buttons: {
            save: {
                className: 'btn btn-outline-warning mx-1',
                id: 'btnModalCommonAreasSave',
            },
            back: {
                className: 'btn btn-outline-success',
                id: 'btnModalCommonAreasBack',
            },
            close: {
                className: 'close btn-danger fas fa-window-close',
                id: 'btnModalCommonAreasClose',
            },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        // dataTables: {
        //     buildings: {
        //         inputs: {
        //             search: {
        //                 id: `${dtBuildingsId}_filter input`,
        //                 className: '',
        //             },
        //         },
        //         selects: {
        //             entries: {
        //                 id: `${dtBuildingsId}_length select`,
        //                 className: '',
        //             },
        //         },
        //     },
        // },
        icons: {
            save: {
                id: 'iconModalCommonAreasSave',
                className: icons?.save,
            },
            back: {
                id: 'iconModalCommonAreasBack',
                className: icons?.arrowCircleLeft,
            },
        },
        inputs: {
            area: {
                id: 'inputModalCommonAreasArea',
                className: 'form-control',
            },
            remark: {
                id: 'inputModalCommonAreasRemark',
                className: 'form-control',
            },
            // model: {
            //     id: 'inputModalCommonAreasModel',
            //     className: 'form-control',
            // },
            // manufactured: {
            //     id: 'inputModalCommonAreasManufactured',
            //     className: 'form-control datetimepicker-input',
            // },
            // serial: {
            //     id: 'inputModalCommonAreasSerial',
            //     className: 'form-control',
            // },
            // type: {
            //     id: 'inputModalCommonAreasType',
            //     className: 'form-control',
            // },
            // cost: {
            //     id: 'inputModalCommonAreasCost',
            //     className: 'form-control text-right',
            // },
        },
        // radios: {
        //     even: {
        //         id: 'radioModalCommonAreasEven',
        //         className: 'icheck-primary d-inline mx-4',
        //     },
        //     odd: {
        //         id: 'radioModalCommonAreasOdd',
        //         className: 'icheck-primary d-inline',
        //     },
        //     both: {
        //         id: 'radioModalCommonAreasBoth',
        //         className: 'icheck-primary d-inline mx-4',
        //     },
        // },
        spinners: {
            save: {
                id: 'spModalCommonAreasSave',
                className: '',
            },
            back: {
                id: 'spModalCommonAreasBack',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion variables

    //#region methods
    const defaultValueSetAsync = async ({ isModalClose = false, subMethod = '', }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            if (isModalClose) {
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });

                response = await errosDefaultSetAsync({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                    return;
                }

                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                processValues.setShowModal(!isModalClose);
            }
            buildingTwo = building;
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const formDataSetAsync = async ({ property = '', value = '', subMethod = '', }) => {
        const currentMethod = 'formDataSetAsync';
        let response = responseGet();
        try {
            setCommonArea({ ...commonArea, [property]: value, });

            //#region set remark remaining
            if (property === 'remark') {
                setRemarkRemaining(
                    charactersRemainingGet({
                        text: value,
                        maxLength: remarkMaxLength,
                        msgText: `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                        subMethod: currentMethod,
                    }).result
                );
            }
            //#endregion set remark remaining
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const formDataValidateAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'formDataValidateAsync';
        let response = responseGet();
        try {
            if (isUndNullEmp({ data: commonArea?.area, subMethod: currentMethod, })?.result) {
                setAreaError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const errosDefaultSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'errosDefaultSetAsync';
        let response = responseGet();
        try {
            setAreaError('');
            setRemarkError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const commonAreaAddPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'commonAreaAddPostAsync';
        let response = responseGet();
        try {
            //#region variables
            let commonAreaFound = [];
            //#region response is warning
            let responseIsWarning = responseGet();
            responseIsWarning.isWarning = true;
            responseIsWarning.msgType = 1;
            //responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
            //#endregion response is warning
            //#endregion variables

            //#region initialize
            e?.preventDefault();

            response = await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion initialize

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region data save
            //if (processValues?.type === 0) {
            //#region find common area
            if (isUndNullEmp({ data: building?.commonAreas, subMethod: currentMethod, })?.result) {
                building.commonAreas = [];
            }

            //#region by area
            commonAreaFound = building?.commonAreas?.find(({ area }) => area === commonArea?.area);
            if (!isUndNullEmp({ data: commonAreaFound, subMethod: currentMethod, })?.result) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                responseIsWarning.msgText = `${messages?.thisInformationHasAlreadyBeenRecorded?.[languageObj?.id]}:<br/>`;
                responseIsWarning.msgText += `<b>${commonArea?.area}</b><br/>`;
                responseIsWarning.msgText += `${messages?.pleaseEnterDifferentOne?.[languageObj?.id]}`;
                await sendMessageCloseCurrentWindowAsync({
                    msgType: responseIsWarning?.msgType,
                    msgText: !isUndNullEmp({ data: responseIsWarning?.msgHtml, subMethod: currentMethod, })?.result ? responseIsWarning?.msgHtml : responseIsWarning?.msgText,
                    closeWindow: false,
                    urlGoTo: responseIsWarning?.urlGoTo,
                    auth: processValues?.auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion by area
            //#endregion find common area

            //#region update common areas
            building?.commonAreas?.push(commonArea);

            headerObj = {
                headers: {
                    authorization: `bearer ${processValues.auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };
            dataObj = {
                commonAreas: building?.commonAreas,
                languageId: languageObj?.id,
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlCommonAreas}/${building?.id}`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                building.commonAreas = building?.commonAreas?.filter(({ id }) => id !== commonArea?.id);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: processValues?.auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            //#endregion update inventories
            $(`#${processValues?.dtId}`)?.DataTable()?.row?.add([
                commonArea?.area,
                buttonProcessGet({
                    id: commonArea?.id,
                    description: commonArea?.area,
                    showDetails: true,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: true,
                    showDelete: true,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: true,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result
            ])?.draw(true);

            //controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            //await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });
            //}
            //#endregion data save

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: '',
                auth: processValues?.auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            building.commonAreas = building?.commonAreas?.filter(({ id }) => id !== commonArea?.id);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const commonAreaEditPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'commonAreaEditPostAsync';
        let response = responseGet();
        try {
            //#region variables
            let commonAreaFound = [];
            //#region response is warning
            let responseIsWarning = responseGet();
            responseIsWarning.isWarning = true;
            responseIsWarning.msgType = 1;
            //responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
            //#endregion response is warning
            //#endregion variables

            //#region initialize
            e.preventDefault();
            response = await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion initialize

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region data save
            // if (processValues?.type === 1) {
            //#region find common area
            if (isUndNullEmp({ data: building?.commonAreas, subMethod: currentMethod, })?.result) {
                building.commonAreas = [];
            }

            //#region by area
            commonAreaFound = building?.commonAreas?.find(({ id, area }) => area === commonArea?.area && id !== commonArea?.id);
            if (!isUndNullEmp({ data: commonAreaFound, subMethod: currentMethod, })?.result) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                responseIsWarning.msgText = `${messages?.thisInformationHasAlreadyBeenRecorded?.[languageObj?.id]}:<br/>`;
                responseIsWarning.msgText += `<b>${commonArea?.area}</b><br/>`;
                responseIsWarning.msgText += `${messages?.pleaseEnterDifferentOne?.[languageObj?.id]}`;
                await sendMessageCloseCurrentWindowAsync({
                    msgType: responseIsWarning?.msgType,
                    msgText: !isUndNullEmp({ data: responseIsWarning?.msgHtml, subMethod: currentMethod, })?.result ? responseIsWarning?.msgHtml : responseIsWarning?.msgText,
                    closeWindow: false,
                    urlGoTo: responseIsWarning?.urlGoTo,
                    auth: processValues?.auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion by area
            //#endregion find common area

            //#region delete element from elevators
            building.commonAreas = building?.commonAreas?.filter(({ id }) => id !== commonArea?.id);
            //#endregion delete element from elevators

            //#region update common area
            building?.commonAreas?.push(commonArea);

            headerObj = {
                headers: {
                    authorization: `bearer ${processValues.auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };
            dataObj = {
                commonAreas: building?.commonAreas,
                languageId: languageObj?.id,
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlCommonAreas}/${building?.id}`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                building.commonAreas = building?.commonAreas?.filter(({ id }) => id !== commonArea?.id);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: processValues?.auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            //#endregion update common area
            $(`#${processValues?.dtId}`)?.DataTable()?.row(processValues.rowIndex)?.data?.([
                commonArea?.area,
                buttonProcessGet({
                    id: commonArea?.id,
                    description: commonArea?.area,
                    showDetails: true,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: true,
                    showDelete: true,
                    labelDelete: labels?.delete?.[languageObj?.id],
                    enabledDelete: true,
                    processButtons: [],
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result
            ])?.draw(true);

            //await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });
            // }
            //#endregion data save

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: '',
                auth: processValues?.auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            building.commonAreas = building?.commonAreas?.filter(({ id }) => id !== commonArea?.id);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //#region set status remark remaining
            setRemarkRemaining(
                charactersRemainingGet({
                    text: (!isUndNullEmp({ data: commonArea?.remark, subMethod: currentMethod, })?.result ? commonArea?.remark : ''),
                    maxLength: remarkMaxLength,
                    msgText: `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                    subMethod: currentMethod,
                })?.result
            );
            //#endregion set status remark remaining
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.removeClass();

                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.removeClass();

                    $(`#${controls?.buttons?.back?.id}`)?.removeClass();

                    $(`#${controls?.icons?.save?.id}`)?.addClass(controls?.icons?.save.className);
                    $(`#${controls?.buttons?.save?.id}`)?.addClass(controls?.buttons?.save?.className);
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(controls?.spinners?.save?.className);

                    $(`#${controls?.icons?.back?.id}`)?.addClass(controls?.icons?.back.className);
                    $(`#${controls?.buttons?.back?.id}`)?.addClass(controls?.buttons?.back?.className);
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(controls?.spinners?.back?.className);

                    $(`#${controls?.buttons?.close?.id}`)?.addClass(controls?.buttons?.close?.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.inputs?.area?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.remark?.id}`)?.attr('readOnly', (processType !== 0));
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region old code
            // $(`#${controls?.dataTables?.buildings?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            // $(`#${controls?.dataTables?.buildings?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion old code

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [processValues?.auth]);
    //#endregion methods

    return (
        <Modal backdrop='static' show={processValues?.showModal} onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'modal - btnHeader', })}>
            <Modal.Header>
                <Modal.Title>
                    <img alt='commonAreas'
                        src={images?.partyFlags}
                        style={styles?.cardHeaderLogo}></img> - {labels?.commonArea?.[languageObj?.id]} ({processValues?.type === 0 ?
                            labels?.add?.[languageObj?.id]?.toLowerCase() :
                            processValues?.type === 1 ?
                                labels?.edit?.[languageObj?.id]?.toLowerCase() :
                                labels?.detail?.[languageObj?.id]?.toLowerCase()}
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'modal - btnHeader', })}>
                </button>
            </Modal.Header>
            <form onSubmit={(e) => processValues?.type === 0 ?
                commonAreaAddPostAsync({ e: e, subMethod: 'form - modal' }) : (processValues?.type === 1 ?
                    commonAreaEditPostAsync({ e: e, subMethod: 'form - modal', }) : e?.preventDefault())}>
                <Modal.Body>
                    {/* <div className='card card-primary card-outline shadow' > */}
                    {/* <form onSubmit={(e) => processValues?.type === 0 ? commonAreaAddPostAsync(e) : (processValues?.type === 1 ? commonAreaEditPostAsync(e) : e?.preventDefault())}> */}

                    {/* Header */}
                    {/* <div className='card-header'>
                            <h6 className='card-title'>
                                <img alt={labels?.commonArea?.[languageObj?.id]} src={images?.partyFlags} style={styles?.cardHeaderLogo}></img> - {labels?.commonArea?.[languageObj?.id]}
                            </h6>
                        </div> */}

                    {/* Body */}
                    {/* <div className='card-body'> */}
                    {processValues?.type !== 2 ?
                        <div>
                            <div className='form-group'>
                                <div className='input-group mb-3'>
                                    <input id={controls?.inputs?.area?.id}
                                        className={controls?.inputs?.area?.className}
                                        //autoFocus
                                        placeholder={labels?.area?.[languageObj?.id]}
                                        onChange={(e) => formDataSetAsync({ property: 'area', value: e?.target?.value, subMethod: 'input - area', })}
                                        onFocus={() => setAreaError('')}
                                        value={commonArea?.area || ''}
                                        tooltip='tooltip' title={labels?.area?.[languageObj?.id]} />
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className={icons?.glassCheers} />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(areaError)}</div>
                            </div>

                            <div className='form-group'>
                                <div className='input-group mb-3'>
                                    <textarea id={controls?.inputs?.remark?.id}
                                        className={controls?.inputs?.remark?.className}
                                        maxLength={remarkMaxLength}
                                        onChange={(e) => formDataSetAsync({ property: 'remark', value: e?.target?.value, subMethod: 'input - remark', })}
                                        onFocus={() => setRemarkError('')}
                                        placeholder={labels?.remark?.[languageObj?.id]}
                                        rows={3}
                                        tooltip='tooltip'
                                        title={labels?.remark?.[languageObj?.id]}
                                        value={commonArea?.remark || ''}>
                                    </textarea>
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className={icons?.edit} />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles.labelMsgInfo}>{HtmlParser(remarkRemaining)}</div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(remarkError)}</div>
                            </div>
                        </div>
                        :
                        <div>
                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    <b>{labels?.area?.[languageObj?.id]}:</b>
                                </div>
                                <div className='col-md-8'>
                                    {!isUndNullEmp({ data: commonArea?.area, subMethod: currentMethod, })?.result ? commonArea?.area : ''}
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    <b>{labels?.remark?.[languageObj?.id]}:</b>
                                </div>
                                <div className='col-md-8'>
                                    {!isUndNullEmp({ data: commonArea?.remark, subMethod: currentMethod, })?.result ?
                                        HtmlParser(commonArea?.remark?.replaceAll('\n', '<br/>')) : ''}
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-12'>
                                    <hr />
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    <b>{labels?.date?.[languageObj?.id]}:</b>
                                </div>
                                <div className='col-md-8'>
                                    {dateTimeFormatGlobalSet({
                                        date: !isUndNullEmp({ data: commonArea?.created, subMethod: 'label - created', })?.result ? commonArea?.created : new Date(),
                                        type: languageObj?.format?.date?.f1,
                                        format: languageObj?.format?.time?.type,
                                        addTime: false,
                                        languageId: languageObj?.id,
                                        subMethod: 'label - created'
                                    })?.result}
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    <b>{labels?.user?.[languageObj?.id]}:</b>
                                </div>
                                <div className='col-md-8'>
                                    {!isUndNullEmp({ data: processValues?.user, subMethod: 'label - user', })?.result ? `${processValues?.user?.firstName || ''} ${processValues?.user?.lastName || ''}` : ''}
                                </div>
                            </div>
                        </div>
                    }

                    {/* </div> */}

                    {/* Footer */}
                    {/* <div className='card-footer'>
                            <div className='form-group text-right'>
                                {processValues?.type !== 2 ?
                                    <button className='btn btn-outline-warning mx-1'
                                        tooltip='tooltip'
                                        title={processValues?.type === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                                        type='submit'>
                                        <i className={icons?.save}></i>
                                    </button>
                                    : <></>
                                }
                                <button className='btn btn-outline-success'
                                    tooltip='tooltip'
                                    title={labels?.close?.[languageObj?.id]}
                                    type='reset'
                                    onClick={() => defaultValueSetAsync(true)}>
                                    <i className={icons?.arrowCircleLeft}></i>
                                </button>
                            </div>
                        </div> */}

                    {/* </form> */}
                    {/* </div> */}
                </Modal.Body>
                <Modal.Footer>
                    <div className='form-group text-right'>
                        {processValues?.type !== 2 ?
                            <button id={controls?.buttons?.save?.id}
                                className={controls?.buttons?.save?.className}
                                //className='btn btn-outline-warning mx-1'
                                tooltip='tooltip'
                                title={processValues?.type === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                                type='submit'>
                                <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                            </button>
                            : <></>
                        }
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.className}
                            //className='btn btn-outline-success'
                            tooltip='tooltip'
                            title={labels?.close?.[languageObj?.id]}
                            type='reset'
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'modal - btnFooter', })}>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}